import { useAppSelector } from '../../../core/utils';
import useFetchLayoutServiceAssets from '../../../core/apiHooks/useFetchLayoutServiceAssets';
import { selectTransmissionFromCurrentVehicle } from '../../../core/reducers/vehicles';
/**
 *  Fetch assets for first exterior color as placeholder
 */
const usePlaceholderAssets = (transmissionId) => {
    var _a, _b;
    const currentTransmission = useAppSelector(selectTransmissionFromCurrentVehicle);
    const firstExtColor = (_a = currentTransmission === null || currentTransmission === void 0 ? void 0 : currentTransmission.exteriorColors) === null || _a === void 0 ? void 0 : _a[0];
    const { data: placeholderColorAssets, isSuccess: isSuccessPlaceholder } = useFetchLayoutServiceAssets({
        transmissionId,
        exteriorColorKey: firstExtColor === null || firstExtColor === void 0 ? void 0 : firstExtColor.key,
        interiorColorKey: firstExtColor === null || firstExtColor === void 0 ? void 0 : firstExtColor.defaultInteriorColor,
    });
    // first image is used for placeholder "coming soon" image
    const placeholderImage = (_b = placeholderColorAssets === null || placeholderColorAssets === void 0 ? void 0 : placeholderColorAssets.exteriorImages) === null || _b === void 0 ? void 0 : _b[0];
    return {
        placeholderImage,
        placeholderColorAssets,
        isSuccessPlaceholder,
    };
};
export default usePlaceholderAssets;
